var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRasterSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_raster_success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_raster_success",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#009527",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 13,
    cy: 13,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0360672,15.2704384 C11.664866,15.6786695 11.0631948,15.6784145 10.6851699,15.2621306 L8.04135512,12.3507416 C7.66647638,11.9379223 7.06017708,11.9339262 6.68128855,12.3482229 L6.68128855,12.3482229 C6.30502328,12.7596511 6.30375789,13.4276801 6.66850222,13.8293394 L10.6954457,18.2638403 C11.0646493,18.6704101 11.6713096,18.661531 12.0416044,18.2537595 L19.3223435,10.2361541 C19.6966028,9.82401681 19.6997296,9.15925344 19.3235093,8.74495677 L19.3235093,8.74495677 C18.9498937,8.33352851 18.3524931,8.32390627 17.9748992,8.73916775 L12.0360672,15.2704384 Z",
    id: "Shape",
    fill: "#009527"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRasterSuccess);
export default __webpack_public_path__ + "static/media/icon_raster_success.1921e171188d7736ed5a9b4dfa3e595d.svg";
export { ForwardRef as ReactComponent };